import { Cookie } from '@tools/cookie';

export const seenOffers = () => {
  const SEEN_OFFERS_COOKIE_NAME = 'seen_offers';

  window.addEventListener('load', () => {
    const offers = Cookie.get(SEEN_OFFERS_COOKIE_NAME) ? JSON.parse(Cookie.get(SEEN_OFFERS_COOKIE_NAME)) : [];
    offers.push(window.initialAppState.offer_id.toString());
    Cookie.setJSON(SEEN_OFFERS_COOKIE_NAME, [ ...new Set(offers) ]);
  });
};
